import axios from './axios'
import { CreateReceiptDto, ReceiptDto } from './types'

export const getReceipts = (params?: { customerId?: string; paymentType?: string; status?: string }) => {
  return axios.get<ReceiptDto[]>('/receipts', { params })
}

export const getReceipt = (id: string) => {
  return axios.get<ReceiptDto>(`/receipts/${id}`)
}

export const createReceipt = (data: CreateReceiptDto) => {
  return axios.post<ReceiptDto>('/receipts', data)
}

export const cancelReceipt = (id: string) => {
  return axios.patch<ReceiptDto>(`/receipts/${id}/cancel`)
}
